/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'gatsby'
import styles from './styles.module.css'
import photoNavigationShape from 'shapes/PhotoNavigation'

const PhotosSidebar = ({ className, photoNavigation }) => {
  const listings = photoNavigation.map(({ slug, title }) => (
    <li key={slug}>
      <Link to={slug} activeClassName={styles.active}>
        {title}
      </Link>
    </li>
  ))

  return (
    <section className={cx(className, styles.PhotoSidebar)}>
      <header>
        <h3>Photos</h3>
      </header>
      <nav>
        <ul>{listings}</ul>
      </nav>
    </section>
  )
}

PhotosSidebar.propTypes = {
  className: PropTypes.string,
  photoNavigation: photoNavigationShape.list,
}

export default PhotosSidebar
